module.exports = __webpack_public_path__ + "1f1c07edcf3054fe1ec899ace9e99ad7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_1_0.woff
// module id = 2248
// module chunks = 2